module.exports = __webpack_public_path__ + "static/audiofuturo-96a2519f1ed821c6fb913d6282dad02c.mp3";